import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { usePageTitle } from "@/hooks/usePageTitle";

export default function About() {
  usePageTitle(
    "About",
    "WeAutomate is India's applied-intelligence company: hardware, software, and the automation that makes them one product. About us, our story, our stance."
  );
  return (
    <div className="py-20">
      <div className="mx-auto max-w-3xl px-6 lg:px-10">
        <div className="text-[11px] uppercase tracking-widest text-white/40 font-mono">About</div>
        <h1 className="font-display text-4xl lg:text-6xl mt-3 tracking-tighter">
          A company built like <span className="gradient-text">a product</span>.
        </h1>
        <p className="mt-6 text-white/70 leading-relaxed">
          WeAutomate is an India-first technology company with an unusually wide reach: we engineer hardware,
          build software, and automate physical spaces — and we package all of it under one umbrella, so a
          single partner can take an idea from sketch to shipped, and from product to market.
        </p>
        <p className="mt-4 text-white/70 leading-relaxed">
          We build on our own businesses first, then bring what works to yours.
        </p>

        <div className="mt-10 border-l-2 border-accent/40 pl-5">
          <p className="text-lg text-white/80 leading-relaxed italic">
            "One partner. From first sketch to shipped product."
          </p>
        </div>

        <div className="mt-12 grid sm:grid-cols-3 gap-5">
          {[
            { k: "Vision", v: "Be India's most respected applied-intelligence company." },
            { k: "Mission", v: "Make automation luxurious at home and inevitable at work." },
            { k: "Values", v: "Ship. Respect IP. Compound. Be kind." },
          ].map(({ k, v }) => (
            <div key={k} className="glass rounded-2xl p-6 hover:border-white/20 transition-colors">
              <div className="text-[10px] uppercase tracking-widest text-accent font-mono">{k}</div>
              <p className="mt-3 text-sm text-white/80 leading-relaxed">{v}</p>
            </div>
          ))}
        </div>
        <Link to="/contact" className="mt-12 inline-flex items-center gap-2 px-6 py-3 rounded-full gradient-bg font-medium">
          Talk to us <ArrowRight className="w-4 h-4" />
        </Link>
      </div>
    </div>
  );
}
